/** This enumeration states whether a product stock status is in stock or out of stock */
export enum ProductStockStatus {
    InStock = 'IN_STOCK',
    OutOfStock = 'OUT_OF_STOCK'
}
